/* eslint-disable */
/* tslint:disable */
// THIS FILE IS AuTo-GeNeRaTeD BY barrel-rider-sidecar. DO NOT EDIT
// see: https://www.npmjs.com/package/barrel-rider-sidecar
import * as jobAwayCarriedCargo from './jobAwayCarriedCargo'
export { jobAwayCarriedCargo }